

var Defaultbasicprops = {  
    "font_data": {
        "fontsize": 20,
        "fonttype": "Roboto"
    },
    "title_text": {
        "fontsize": 16,
        "fonttype": "Roboto"
    },
    "color": {
        "light": {
            "background": "#FFFFFF",
            "text": "#1E8EFA",
            "border": "#008CD7",
            "icon": "#C2CBC8"
        },
        "dark": {
            "background": "#1E1E1E",
            "text": "#1E8EFA",
            "border": "#008CD7",
            "icon": "#C2CBC8"
        }
    },
    "border": {
        "borderradius": 0,
        "bordersize": 0
    },
}

export default Defaultbasicprops